import { Component, Input, } from '@angular/core';

import { UserContextService } from 'rev-shared/security/UserContext.Service';

import { ThemeService } from './Theme.Service';

import './branding-preview-banner.less';

@Component({
	selector: 'branding-preview-banner',
	templateUrl: './BrandingPreviewBanner.Component.html',
	standalone: false
})
export class BrandingPreviewBannerComponent {
	@Input() public isGuestMode: boolean;

	public accountId: string;

	constructor(
		private readonly ThemeService: ThemeService,
		UserContext: UserContextService
	) {
		this.accountId = UserContext.getAccount().id;
	}

	public get isPreviewActive(): boolean {
		return this.ThemeService.isPreviewActive;
	}
}
